@if(data?.tabs) {
    <div class="tab-container" [id]="parentId | idGenerator: tabIdPrefix">
        <div class="top-section">
            @if(data.headerData) {
                <finder-component-header
                    class="header"
                    [data]="data.headerData">
                </finder-component-header>
            }
            @if (tabs) {
                <div class="tabs" [ngClass]="data.type" role="tablist">
                    <!-- It is recommended to use <button> elements with the role tab
                        for their built-in functional and accessible features. See:
                        https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/tab_role#best_practices -->
                    @for (tab of tabs; track $index) {
                        <finder-button
                            class="tab"
                            [anchor]="true"
                            [ngClass]="{'selected': tab.selected, 'show-indicator': data.showIndicator}"
                            [tabIndex]="tab.selected ? 0 : -1"
                            [ariaControls]="tab.id | idGenerator: tabIdPrefix : parentId"
                            [ariaSelected]="tab.selected"
                            ariaRole="tab"
                            (keydown.shift.tab)="setSelected(tab.id - 1)"
                            (keydown.tab)="setSelected(tab.id + 1)"
                            (click)="setSelected(tab.id)"
                        >
                            @if (tab.icon) {
                                <finder-picture [picture]="tab.icon"></finder-picture>
                            }
                            @if (tab.title) {
                                <span class="title" [innerHTML]="tab.title"></span>
                            }
                            @if (tab.subtitle) {
                                <span class="subtitle" [innerHTML]="tab.subtitle"></span>
                            }
                        </finder-button>
                    }
                </div>
            }
        </div>
        @if (data.panels) {
            <div class="content">
                <finder-tab-content-renderer
                    [panels]="data.panels"
                    [activeTab]="activeTab"
                    [tabIdPrefix]="tabIdPrefix"
                    [parentId]="parentId"
                    [tabChange]="activeTab$.asObservable()"
                    [tabFriendlyId]="tabFriendlyId"
                ></finder-tab-content-renderer>
            </div>
        }
        @if (data.disclaimer) {
            <finder-disclaimer [disclaimer]="data.disclaimer"></finder-disclaimer>
        }
    </div>
}